(function () {
	angular
		.module('trackeye')
		.factory('HttpQueue', _HttpQueueFactory);

	_HttpQueueFactory.$inject = ['$q', '$http'];

	/**
	 * Queue http calls, to avoid spamming a server
	 * with multiple requests, simultaneously.
	 * @param  {[type]} $q    [description]
	 * @param  {[type]} $http [description]
	 *
	 * @return {Object}
	 */
	function _HttpQueueFactory($q, $http) {
		var httpQueue = {},
			queueTimeout = {},
			exports = {};

		/**
		 * Add $http config to the queue
		 * @param {string} name
		 * @param {Object} config $http config
		 * @returns {Promise}
		 */
		exports.add = function (name, config, parallel) {
			var deferred = $q.defer();

			if (!name) {
				deferred.resolve();
				return deferred.promise;
			}

			var	queue = getQueueList(name, parallel);

			queue.push({
				deferred: deferred,
				config: config
			});

			if (queue.length === 1) {
				clearTimeout(queueTimeout[name]);

				queueTimeout[name] = setTimeout(function () {
					processQueue(name);
				}, 50);
			}

			return deferred.promise;
		};

		exports.cancel = function (name) {
			if (httpQueue[name]) {
				httpQueue[name].queue = [];
			}

			return true;
		};

		exports.resolve = function (name) {
			queueResolve(name);
		}

		exports.reject = function (name, data) {
			queueReject(name, data);
		}

		exports.promise = function (name) {
			var queue = getQueue(name);

			return queue.deferred.promise;
		};

		function getQueue (name, parallel) {
			if (!httpQueue[name]) {
				return httpQueue[name] = {
					deferred: $q.defer(),
					response: [],
					queue: [],
					parallel: parallel
				};
			}
			return httpQueue[name];
		}

		function getQueueList(name, parallel) {
			var queue = getQueue(name, parallel);
			return queue.queue;
		}

		function queueReject (name, data) {
			var queue = getQueue(name);
			
			queue.deferred.reject(data);

			delete httpQueue[name];
		}

		function queueResolve (name, data) {
			var queue = getQueue(name);

			queue.deferred.resolve(queue.response);

			delete httpQueue[name];
		}

		function processQueue(name) {
			var queue = getQueue(name),
				queueList = queue.queue,
				task = queueList.shift();

			if (!task || !task.config) {
				queueResolve(name);
				return;
			}

			if (queue.parallel > 0) {
				// executeParallel
			} else {
				// executeSingle
			}

			$http(task.config).then(function (data) {
				task.deferred.resolve(data);
				queue.response.push(data);

				if (queueList.length > 0) {
					processQueue(name);
				} else {
					queueResolve(name)
				}

			}, function (data) {
				if (data.is50x()) {
					queueList = [];
					task.deferred.reject(data);
				}

				if (queueList.length > 0) {
					processQueue(name);
				} else {
					queueResolve(name);
				}
			});
		}

		return exports;
	}
}());
